import { palette } from '../palette';
import colors from '../colors';
import baseTheme from '../baseTheme';
var MuiAppBar = {
    /* your custom class style overrides here */
    root: {
        boxShadow: 'none',
        borderBottom: "1px solid #00000020",
    },
    colorPrimary: {
        backgroundColor: colors.darkBlue[500],
        color: palette.common.white,
    },
    colorDefault: {
        backgroundColor: baseTheme.palette.grey[100],
        color: baseTheme.palette.text.primary,
    },
    colorSecondary: {
        backgroundColor: colors.greyscale[100],
        color: palette.common.white,
    },
};
export default MuiAppBar;
//# sourceMappingURL=MuiAppBar.js.map